<template>
  <div class="flex flex-col bg-[#f8fafc] gap-4">
    <FinanceToast :show="toast.show" :variant="toast.variant">{{ toast.message }}</FinanceToast>
    <div class="bg-white rounded-xl shadow-sm border border-slate-200 border-t-4 border-t-[#0d4169] flex flex-col pt-3">
      <div class="relative z-30 px-6 pb-3 flex flex-col gap-4 border-b border-slate-100 bg-white">
        <h2 class="text-base font-bold text-[#0d4169] text-left m-0">HR</h2>
      </div>

      <div class="relative z-0 px-4 sm:px-6 py-4 min-w-0">
        <div class="bg-white shadow-sm border border-slate-200 overflow-hidden min-w-0">
          <div class="px-4 sm:px-6 pt-2 pb-1">
            <div class="flex items-baseline gap-2 flex-wrap">
              <h2 class="text-base font-bold text-[#0d4169] text-left">
                Device  Attendance
              </h2>
            </div>
            <p
              v-if="reportTitle && activeReportType !== 'Detail'"
              class="mt-1 text-xs text-slate-500 text-left m-0"
            >
              {{ reportTitle }}
            </p>
          </div>

          <form class="px-4 sm:px-6 pt-2" @submit.prevent="findAttendance">
            <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 items-end gap-3 min-w-0">
              <div class="flex flex-col gap-1 min-w-0">
                <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">Search Key</label>
                <select
                  v-model="filters.searchKey"
                  class="w-full min-w-0 px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm bg-white"
                  required
                  @change="onSearchKeyChange"
                >
                  <option value="" disabled>Select Here</option>
                  <option value="id">By ID</option>
                  <option value="department">By Department</option>
                  <option value="all">All</option>
                </select>
              </div>

              <div class="flex flex-col gap-1 min-w-0">
                <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">Department</label>
                <select
                  v-model="filters.departmentId"
                  :disabled="!isDepartmentSearch"
                  class="w-full min-w-0 px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm bg-white disabled:bg-slate-100 disabled:text-slate-400"
                  :required="isDepartmentSearch"
                >
                  <option value="" disabled>Select Here</option>
                  <option
                    v-for="dep in departments"
                    :key="dep.id"
                    :value="String(dep.id)"
                  >
                    {{ dep.name }}
                  </option>
                </select>
              </div>

              <div class="flex flex-col gap-1 min-w-0">
                <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">ID Number</label>
                <input
                  v-model.trim="filters.employeeId"
                  type="text"
                  inputmode="numeric"
                  :disabled="!isIdSearch"
                  class="w-full min-w-0 px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm bg-white disabled:bg-slate-100 disabled:text-slate-400"
                  placeholder="Employee ID"
                  :required="isIdSearch"
                >
              </div>

              <div class="flex flex-col gap-1 min-w-0">
                <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">Report Type</label>
                <select
                  v-model="filters.reportType"
                  class="w-full min-w-0 px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm bg-white"
                  required
                  @change="onReportTypeChange"
                >
                  <option value="" disabled>Select Here</option>
                  <option value="Summary">Summary /Device</option>
                  <option value="Detail">Detail /Device</option>
                  <option value="Monthly_M">Monthly /Confirm</option>
                  <option value="Shift_Schdules">Shift Schedule</option>
                </select>
              </div>

              <div class="flex flex-col gap-1 min-w-0">
                <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">Shift Type</label>
                <select
                  v-model="filters.shiftId"
                  :disabled="!isShiftSchedule"
                  class="w-full min-w-0 px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm bg-white disabled:bg-slate-100 disabled:text-slate-400"
                  :required="isShiftSchedule"
                >
                  <option value="" disabled>Select Here</option>
                  <option
                    v-for="shift in shifts"
                    :key="shift.id"
                    :value="String(shift.id)"
                  >
                    {{ shift.shiftName }}
                  </option>
                </select>
              </div>

             

              <div class="flex flex-col gap-1 min-w-0">
                <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">Date From</label>
                <input
                  v-model="filters.dateFrom"
                  type="date"
                  :max="today"
                  class="w-full min-w-0 px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm bg-white"
                  :required="!filters.month"
                  @change="onDateChange"
                >
              </div>

              <div class="flex flex-col gap-1 min-w-0">
                <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">Date To</label>
                <input
                  v-model="filters.dateTo"
                  type="date"
                  :max="today"
                  :disabled="isMonthlyConfirm"
                  class="w-full min-w-0 px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm bg-white disabled:bg-slate-100 disabled:text-slate-400"
                  :required="!isMonthlyConfirm && !filters.month"
                  @change="onDateChange"
                >
              </div>

<div class="flex flex-col gap-1 min-w-0">
  <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">Month</label>
  <select
    v-model="filters.month"
    class="w-full min-w-0 px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm bg-white"
    @change="onMonthChange"
  >
    <option value="">Select Here</option>
    <option
      v-for="month in monthOptions"
      :key="month.value"
      :value="month.value"
    >
      {{ month.label }}
    </option>
  </select>
</div>

              <div class="flex justify-center min-w-0">
                <button
                  type="submit"
                  :disabled="loading || optionsLoading || !canFindAttendance || !isAttendanceDeviceEnabled"
                  class="min-w-max px-8 py-1.5 bg-[#0d4169] text-white text-sm font-bold rounded-md shadow-md hover:bg-[#0a3354] transition-all active:scale-95 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                  <div
                    v-if="loading"
                    class="h-5 w-5 border-2 border-white/30 border-t-transparent rounded-full animate-spin"
                  ></div>
                  <span v-if="!loading">Find</span>
                </button>
              </div>
            </div>
            <p v-if="errorMessage" class="mt-2 text-xs text-red-600 text-left">{{ errorMessage }}</p>
            <p v-if="optionsError" class="mt-2 text-xs text-amber-600 text-left">{{ optionsError }}</p>
          </form>

          <div class="px-4 sm:px-6 pb-6 pt-4 min-w-0">
            <!-- Detail report: PHP-style per-employee date tables -->
            <div v-if="activeReportType === 'Detail' && hasSearched" class="space-y-6">
              <div
                v-if="reportTitle"
                class="text-sm font-semibold text-[#0d4169] text-left leading-relaxed"
              >
                <div>{{ reportTitleMain }}</div>
                <div class="text-slate-500 font-medium">From {{ reportDateFrom }} - {{ reportDateTo }}</div>
              </div>

              <div v-if="loading" class="flex items-center justify-center py-10">
                <div class="h-8 w-8 border-4 border-gray-300 border-t-transparent rounded-full animate-spin"></div>
              </div>

              <p
                v-else-if="rows.length === 0"
                class="text-center text-slate-400 italic py-12 m-0"
              >
                No attendance records found.
              </p>

              <div
                v-for="emp in rows"
                :key="emp.id"
                class="w-full max-w-full overflow-x-auto overscroll-x-contain"
              >
                <table class="w-full min-w-[640px] border-collapse bg-white rounded-xl shadow-sm">
                  <thead>
                    <template v-if="emp.officeHour === 'Yes'">
                      <tr>
                        <th rowspan="3">Date</th>
                        <th :colspan="10" class="text-[12px]">
                          Emp id: {{ emp.empId }} Name: {{ emp.fullName }} Shift: {{ emp.shiftName }}
                        </th>
                      </tr>
                      <tr>
                        <th colspan="4" class="text-[12px]">{{ emp.timeName || 'Shift 1' }}</th>
                        <th colspan="4" class="text-[12px]">{{ emp.timeName2 || 'Shift 2' }}</th>
                        <th colspan="2" class="text-[12px]">Summary</th>
                      </tr>
                      <tr>
                        <th class="text-[12px]">Check in</th>
                        <th class="text-[12px]">Check Out</th>
                        <th class="text-[12px]">On Duty</th>
                        <th class="text-[12px]">Off Duty</th>
                        <th class="text-[12px]">Check in</th>
                        <th class="text-[12px]">Check Out</th>
                        <th class="text-[12px]">On Duty</th>
                        <th class="text-[12px]">Off Duty</th>
                        <th class="text-[12px]">On Duty</th>
                        <th class="text-[12px]">Off Duty</th>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <th rowspan="2">Date</th>
                        <th colspan="4" class="text-[12px]">
                          Emp id: {{ emp.empId }} Name: {{ emp.fullName }} Shift: {{ emp.shiftName }}
                        </th>
                      </tr>
                      <tr>
                        <th class="text-[12px]">Check in</th>
                        <th class="text-[12px]">Check Out</th>
                        <th class="text-[12px]">On Duty</th>
                        <th class="text-[12px]">Off Duty</th>
                      </tr>
                    </template>
                  </thead>
                  <tbody class="text-[12px]">
                    <tr
                      v-for="day in (emp.days || [])"
                      :key="`${emp.id}-${day.date}`"
                      class="hover:bg-slate-100/50 transition-colors border-b"
                    >
                      <td class="font-medium text-slate-500">{{ day.date }}</td>
                      <template v-if="emp.officeHour === 'Yes'">
                        <td>
                          <span :class="punchClass(day.checkInColor)">{{ formatPunch(day.checkIn) }}</span>
                        </td>
                        <td>
                          <span :class="punchClass(day.checkOutColor)">{{ formatPunch(day.checkOut) }}</span>
                        </td>
                        <td>{{ formatPunch(day.onDuty) }}</td>
                        <td>{{ formatPunch(day.offDuty) }}</td>
                        <td>
                          <span :class="punchClass(day.slot2?.checkInColor)">{{ formatPunch(day.slot2?.checkIn) }}</span>
                        </td>
                        <td>
                          <span :class="punchClass(day.slot2?.checkOutColor)">{{ formatPunch(day.slot2?.checkOut) }}</span>
                        </td>
                        <td>{{ formatPunch(day.slot2?.onDuty) }}</td>
                        <td>{{ formatPunch(day.slot2?.offDuty) }}</td>
                        <td>{{ formatPunch(day.summaryOnDuty || day.onDuty) }}</td>
                        <td>{{ formatPunch(day.summaryOffDuty || day.offDuty) }}</td>
                      </template>
                      <template v-else>
                        <td>
                          <span :class="punchClass(day.checkInColor)">{{ formatPunch(day.checkIn) }}</span>
                        </td>
                        <td>
                          <span :class="punchClass(day.checkOutColor)">{{ formatPunch(day.checkOut) }}</span>
                        </td>
                        <td>{{ formatPunch(day.onDuty) }}</td>
                        <td>{{ formatPunch(day.offDuty) }}</td>
                      </template>
                    </tr>
                  </tbody>
                  <tfoot v-if="emp.totals" class="text-[12px]">
                    <tr>
                      <th :colspan="emp.officeHour === 'Yes' ? 9 : 3" class="footer-label">
                        Total OnDuty / OffDuty
                      </th>
                      <th>{{ emp.totals.onDuty }}</th>
                      <th>{{ emp.totals.offDuty }}</th>
                    </tr>
                    <tr>
                      <th :colspan="emp.officeHour === 'Yes' ? 9 : 3" class="footer-label">
                        Total On Duty + Off Duty (HH:MM)
                      </th>
                      <th>{{ emp.totals.onOff }}</th>
                      <th></th>
                    </tr>
                    <tr>
                      <th :colspan="emp.officeHour === 'Yes' ? 9 : 3" class="footer-label">
                        Total Shift Off Duty (HH:MM) - (Days)
                      </th>
                      <th>{{ emp.totals.shiftOffDuty }}</th>
                      <th></th>
                    </tr>
                    <tr>
                      <th :colspan="emp.officeHour === 'Yes' ? 9 : 3" class="footer-label">
                        Total Employee Off Duty (HH:MM) - (Days)
                      </th>
                      <th>{{ emp.totals.empOffDuty }}</th>
                      <th></th>
                    </tr>
                    <tr>
                      <th :colspan="emp.officeHour === 'Yes' ? 9 : 3" class="footer-label">
                        Total OnDuty Days
                      </th>
                      <th>{{ emp.totals.onDutyDays }}</th>
                      <th></th>
                    </tr>
                    <tr>
                      <th :colspan="emp.officeHour === 'Yes' ? 9 : 3" class="footer-label">
                        Total Absent Days
                      </th>
                      <th>{{ emp.totals.absentDays }}</th>
                      <th></th>
                    </tr>
                    <tr>
                      <th :colspan="emp.officeHour === 'Yes' ? 9 : 3" class="footer-label">
                        Total Working Days
                      </th>
                      <th>{{ emp.totals.workingDays }}</th>
                      <th></th>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>

            <!-- Summary / Monthly / Shift Schedule flat tables -->
            <div v-else class="w-full max-w-full overflow-x-auto overscroll-x-contain">
              <p
                v-if="hasSearched && reportTitle && activeReportType !== 'Detail'"
                class="text-sm font-semibold text-[#0d4169] text-left mb-3 leading-relaxed"
              >
                <span>{{ reportTitleMain }}</span><br>
                <span class="text-slate-500 font-medium">From {{ reportDateFrom }} - {{ reportDateTo }}</span>
              </p>
              <table class="w-full min-w-[980px] border-collapse bg-white rounded-xl shadow-sm">
                <thead>
                  <tr>
                    <th>No.</th>
                    <template v-if="activeReportType === 'Monthly_M'">
                      <th @click="sortBy('fullName')" class="sort-col text-[12px]">
                        Full Name <span v-if="sortKey === 'fullName'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                      </th>
                      <th @click="sortBy('branchDepartment')" class="sort-col text-[12px]">
                        Branch | Department <span v-if="sortKey === 'branchDepartment'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                      </th>
                      <th @click="sortBy('shiftName')" class="sort-col text-[12px]">
                        Shift <span v-if="sortKey === 'shiftName'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                      </th>
                      <th @click="sortBy('duty')" class="sort-col text-[12px]">
                        Duty <span v-if="sortKey === 'duty'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                      </th>
                      <th @click="sortBy('absent')" class="sort-col text-[12px]">
                        Absent <span v-if="sortKey === 'absent'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                      </th>
                      <th @click="sortBy('otHours')" class="sort-col text-[12px]">
                        OT (H) <span v-if="sortKey === 'otHours'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                      </th>
                      <th @click="sortBy('leave')" class="sort-col text-[12px]">
                        Leave <span v-if="sortKey === 'leave'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                      </th>
                    </template>
                    <template v-else-if="activeReportType === 'Shift_Schdules'">
                      <th @click="sortBy('fullName')" class="sort-col text-[12px]">
                        Full Name <span v-if="sortKey === 'fullName'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                      </th>
                      <th @click="sortBy('branchDepartment')" class="sort-col text-[12px]">
                        Branch | Department <span v-if="sortKey === 'branchDepartment'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                      </th>
                      <th @click="sortBy('title')" class="sort-col text-[12px]">
                        Title <span v-if="sortKey === 'title'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                      </th>
                      <th @click="sortBy('shiftName')" class="sort-col text-[12px]">
                        Shift <span v-if="sortKey === 'shiftName'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                      </th>
                      <th @click="sortBy('workDays')" class="sort-col text-[12px]">
                        Work Days <span v-if="sortKey === 'workDays'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                      </th>
                      <th @click="sortBy('offDay')" class="sort-col text-[12px]">
                        Off Day <span v-if="sortKey === 'offDay'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                      </th>
                    </template>
                    <template v-else>
                      <th @click="sortBy('fullName')" class="sort-col text-[12px]">
                        Full Name <span v-if="sortKey === 'fullName'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                      </th>
                      <th @click="sortBy('branchDepartment')" class="sort-col text-[12px]">
                        Branch | Department <span v-if="sortKey === 'branchDepartment'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                      </th>
                      <th @click="sortBy('shiftDaysOff')" class="sort-col text-[12px]">
                        Shift Days Off <span v-if="sortKey === 'shiftDaysOff'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                      </th>
                      <th @click="sortBy('empDaysOff')" class="sort-col text-[12px]">
                        Emp Days Off <span v-if="sortKey === 'empDaysOff'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                      </th>
                      <th @click="sortBy('onDutyDays')" class="sort-col text-[12px]">
                        On Duty Days <span v-if="sortKey === 'onDutyDays'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                      </th>
                      <th @click="sortBy('absentDays')" class="sort-col text-[12px]">
                        Absent Days <span v-if="sortKey === 'absentDays'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                      </th>
                      <th @click="sortBy('leaveDays')" class="sort-col text-[12px]">
                        Leave <span v-if="sortKey === 'leaveDays'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                      </th>
                      <th @click="sortBy('totalDays')" class="sort-col text-[12px]">
                        Total Days <span v-if="sortKey === 'totalDays'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                      </th>
                    </template>
                  </tr>
                </thead>
                <tbody class="text-[12px]">
                  <tr
                    v-for="(row, index) in sortedRows"
                    :key="`${row.id}-${index}`"
                    class="hover:bg-slate-100/50 transition-colors border-b"
                  >
                    <td class="font-medium text-slate-500">{{ index + 1 }}</td>
                    <template v-if="activeReportType === 'Monthly_M'">
                      <td class="font-bold text-[#0d4169]">{{ row.fullName }}</td>
                      <td>
                        <span
                          class="px-2 py-0.5 bg-indigo-50 rounded text-[10px] font-bold text-indigo-600 border border-indigo-200 uppercase tracking-tighter whitespace-nowrap inline-block"
                        >
                          {{ row.branchDepartment }}
                        </span>
                      </td>
                      <td class="text-slate-600 font-medium">{{ row.shiftName || '-' }}</td>
                      <td>{{ row.duty ?? '-' }}</td>
                      <td>{{ row.absent ?? '-' }}</td>
                      <td>{{ row.otHours ?? '-' }}</td>
                      <td>{{ row.leave ?? '-' }}</td>
                    </template>
                    <template v-else-if="activeReportType === 'Shift_Schdules'">
                      <td class="font-bold text-[#0d4169]">{{ row.fullName }}</td>
                      <td>
                        <span
                          class="px-2 py-0.5 bg-indigo-50 rounded text-[10px] font-bold text-indigo-600 border border-indigo-200 uppercase tracking-tighter whitespace-nowrap inline-block"
                        >
                          {{ row.branchDepartment }}
                        </span>
                      </td>
                      <td>
                        <span
                          v-if="row.title"
                          class="px-2 py-0.5 bg-slate-100 rounded text-[10px] font-bold text-slate-600 border border-slate-200 uppercase tracking-tighter whitespace-nowrap inline-block"
                        >
                          {{ row.title }}
                        </span>
                        <span v-else>-</span>
                      </td>
                      <td class="text-slate-600 font-medium">{{ row.shiftName || '-' }}</td>
                      <td>{{ row.workDays ?? '-' }}</td>
                      <td>{{ row.offDay ?? '-' }}</td>
                    </template>
                    <template v-else>
                      <td class="font-bold text-[#0d4169]">{{ row.fullName }}</td>
                      <td>
                        <span
                          class="px-2 py-0.5 bg-indigo-50 rounded text-[10px] font-bold text-indigo-600 border border-indigo-200 uppercase tracking-tighter whitespace-nowrap inline-block"
                        >
                          {{ row.branchDepartment }}
                        </span>
                      </td>
                      <td>{{ row.shiftDaysOff ?? '-' }}</td>
                      <td>{{ row.empDaysOff ?? '-' }}</td>
                      <td>{{ row.onDutyDays ?? '-' }}</td>
                      <td>{{ row.absentDays ?? '-' }}</td>
                      <td>{{ row.leaveDays ?? '-' }}</td>
                      <td class="font-medium text-slate-600">{{ row.totalDays ?? '-' }}</td>
                    </template>
                  </tr>
                  <tr v-if="loading">
                    <td :colspan="tableColspan" class="text-center py-10">
                      <div class="flex items-center justify-center">
                        <div class="h-8 w-8 border-4 border-gray-300 border-t-transparent rounded-full animate-spin"></div>
                      </div>
                    </td>
                  </tr>
                  <tr v-else-if="hasSearched && sortedRows.length === 0">
                    <td
                      :colspan="tableColspan"
                      style="text-align:center; color:#94a3b8; padding: 48px 15px; font-style: italic;"
                    >
                      No attendance records found.
                    </td>
                  </tr>
                  <tr v-else-if="!hasSearched">
                    <td
                      :colspan="tableColspan"
                      style="text-align:center; color:#94a3b8; padding: 48px 15px; font-style: italic;"
                    >
                      Select filters, then click Find.
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                v-if="showSaveButton"
                class="mt-4 flex justify-center"
              >
                <button
                  type="button"
                  :disabled="isSaving || !canSaveAttendance"
                  class="min-w-max px-8 py-1.5 bg-[#0d4169] text-white text-sm font-bold rounded-md shadow-md hover:bg-[#0a3354] transition-all active:scale-95 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
                  @click="onSaveSummary"
                >
                  {{ isSaving ? 'Saving...' : 'Save' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { apiFetch } from '../../../utils/api'
import {
  ETHIOPIAN_MONTH_OPTIONS,
  formatMonthOptionWithAmharic,
  getGregorianRangeForSelectedMonth
} from '../../../utils/ethiopianMonth'
import FinanceToast from '../../finance/FinanceToast.vue'

const API_BASE = '/hr/attendance'
const PRIVILEGE_NAME = 'HR Device Attendance'
const store = useStore()
const currentUser = computed(() => store.getters.currentUser || store.state.user || {})

const userPrivileges = computed(() => {
  const raw = currentUser.value?.privilege
  if (!raw) return {}
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw)
    } catch {
      return {}
    }
  }
  return raw
})

const hasAllPrivilege = computed(() => {
  return userPrivileges.value?.All === true || userPrivileges.value?.all === true
})

function getPrivilegeEntry(key) {
  const priv = userPrivileges.value || {}
  if (!key) return null
  if (priv?.[key]) return priv[key]

  const normalizedNeedle = String(key).trim().toLowerCase()
  const foundKey = Object.keys(priv).find((k) => String(k).trim().toLowerCase() === normalizedNeedle)
  return foundKey ? priv[foundKey] : null
}

function getActionFlag(entry, action) {
  if (!entry || typeof entry !== 'object') return false
  if (!action) return false
  if (entry[action] !== undefined) return !!entry[action]

  const a = String(action)
  const candidates = [
    a.toLowerCase(),
    a.toUpperCase(),
    a.charAt(0).toUpperCase() + a.slice(1).toLowerCase()
  ]
  for (const k of candidates) {
    if (entry[k] !== undefined) return !!entry[k]
  }
  return false
}

const canFindAttendance = computed(() => {
  if (hasAllPrivilege.value) return true
  return getActionFlag(getPrivilegeEntry(PRIVILEGE_NAME), 'Find')
})

/** Company/branch settings.is_attendance_device must be 1 for Find (from filter-options). */
const isAttendanceDevice = ref(0)
const isAttendanceDeviceEnabled = computed(() => Number(isAttendanceDevice.value) === 1)

const canSaveAttendance = computed(() => {
  if (hasAllPrivilege.value) return true
  return getActionFlag(getPrivilegeEntry(PRIVILEGE_NAME), 'Save')
})

const today = new Date().toISOString().slice(0, 10)

const emptyFilters = () => ({
  searchKey: '',
  departmentId: '',
  employeeId: '',
  reportType: '',
  shiftId: '',
  month: '',
  dateFrom: '',
  dateTo: '',
})

const filters = ref(emptyFilters())

const toast = ref({ show: false, message: '', variant: 'success' })
let toastTimer = null

function showToast(message, variant = 'success') {
  if (toastTimer) {
    window.clearTimeout(toastTimer)
    toastTimer = null
  }
  toast.value = { show: true, message, variant }
  const duration = variant === 'error' ? 5000 : 3000
  toastTimer = window.setTimeout(() => {
    toast.value = { show: false, message: '', variant: 'success' }
    toastTimer = null
  }, duration)
}

const monthOptions = ETHIOPIAN_MONTH_OPTIONS.map((month) => ({
  value: month.value,
  label: formatMonthOptionWithAmharic(month)
}))

const departments = ref([])
const shifts = ref([])
const rows = ref([])
const loading = ref(false)
const optionsLoading = ref(false)
const hasSearched = ref(false)
const errorMessage = ref('')
const optionsError = ref('')
const isSaving = ref(false)
const sortKey = ref('fullName')
const sortOrder = ref('asc')
const activeReportType = ref('Summary')
const searchedWithMonth = ref(false)

const isIdSearch = computed(() => filters.value.searchKey === 'id')
const isDepartmentSearch = computed(() => filters.value.searchKey === 'department')
const isMonthlyConfirm = computed(() => filters.value.reportType === 'Monthly_M')
const isShiftSchedule = computed(() => filters.value.reportType === 'Shift_Schdules')
const showSaveButton = computed(() =>
  hasSearched.value &&
  !loading.value &&
  searchedWithMonth.value &&
  Boolean(filters.value.month) &&
  activeReportType.value === 'Summary' &&
  canSaveAttendance.value
)

const reportTitleMain = computed(() => {
  if (!hasSearched.value || !activeReportType.value) return ''
  const labels = {
    Summary: 'Summary Report of Attendance Machine',
    Detail: 'Detail Report of Attendance Machine',
    Monthly_M: 'Summary Report of that Confirm Attendance',
    Shift_Schdules: 'Shift Schedule Report',
  }
  return labels[activeReportType.value] || 'Attendance Report'
})

const reportDateFrom = computed(() => {
  if (filters.value.month) {
    return getMonthDateRange(filters.value.month).dateFrom
  }
  return filters.value.dateFrom || '-'
})
const reportDateTo = computed(() => {
  if (filters.value.month) {
    return getMonthDateRange(filters.value.month).dateTo
  }
  if (activeReportType.value === 'Monthly_M') return filters.value.dateFrom || '-'
  return filters.value.dateTo || '-'
})

const reportTitle = computed(() => {
  if (!reportTitleMain.value) return ''
  return `${reportTitleMain.value} From ${reportDateFrom.value} - ${reportDateTo.value}`
})

const tableColspan = computed(() => {
  if (activeReportType.value === 'Monthly_M') return 8
  if (activeReportType.value === 'Shift_Schdules') return 7
  return 9
})

const sortedRows = computed(() => {
  if (activeReportType.value === 'Detail') return rows.value
  const result = [...rows.value]
  result.sort((a, b) => {
    const modifier = sortOrder.value === 'asc' ? 1 : -1
    const rawA = a[sortKey.value]
    const rawB = b[sortKey.value]
    const numA = Number(rawA)
    const numB = Number(rawB)
    if (Number.isFinite(numA) && Number.isFinite(numB) && String(rawA).trim() !== '' && String(rawB).trim() !== '') {
      if (numA < numB) return -1 * modifier
      if (numA > numB) return 1 * modifier
      return 0
    }
    const valA = (rawA ?? '').toString().toLowerCase()
    const valB = (rawB ?? '').toString().toLowerCase()
    if (valA < valB) return -1 * modifier
    if (valA > valB) return 1 * modifier
    return 0
  })
  return result
})

function sortBy(key) {
  if (sortKey.value === key) {
    sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc'
  } else {
    sortKey.value = key
    sortOrder.value = 'asc'
  }
}

function formatPunch(value) {
  if (value == null || value === '' || value === '00:00:00' || value === '00:00') return '-'
  return String(value)
}

function punchClass(color) {
  if (color === 'success') return 'punch-success'
  if (color === 'danger') return 'punch-danger'
  return ''
}

/**
 * Ethiopian month day 1-30 as Gregorian dates.
 * Example: September | መስከረም -> 2026-09-11 to 2026-10-10
 */
function getMonthDateRange(monthValue) {
  const range = getGregorianRangeForSelectedMonth(monthValue)
  if (!range?.fromDate || !range?.toDate) {
    return { dateFrom: '', dateTo: '' }
  }
  return { dateFrom: range.fromDate, dateTo: range.toDate }
}

function onMonthChange() {
  if (filters.value.month) {
    filters.value.dateFrom = ''
    filters.value.dateTo = ''
  }
}

function onDateChange() {
  if (filters.value.dateFrom || filters.value.dateTo) {
    filters.value.month = ''
  }
}

function onSearchKeyChange() {
  if (!isIdSearch.value) filters.value.employeeId = ''
  if (!isDepartmentSearch.value) filters.value.departmentId = ''
}

function onReportTypeChange() {
  if (isMonthlyConfirm.value) {
    filters.value.dateTo = ''
    filters.value.shiftId = ''
  } else if (!isShiftSchedule.value) {
    filters.value.shiftId = ''
  }
}

async function loadFilterOptions() {
  optionsLoading.value = true
  optionsError.value = ''
  try {
    const res = await apiFetch(`${API_BASE}/filter-options`)
    if (!res.ok) {
      const err = await res.json().catch(() => ({}))
      throw new Error(err.message || 'Failed to load filter options')
    }
    const data = await res.json().catch(() => ({}))
    departments.value = Array.isArray(data.departments) ? data.departments : []
    shifts.value = Array.isArray(data.shifts) ? data.shifts : []
    isAttendanceDevice.value = Number(data.is_attendance_device) === 1 ? 1 : 0
  } catch (err) {
    console.error('Error loading attendance filter options:', err)
    departments.value = []
    shifts.value = []
    isAttendanceDevice.value = 0
    optionsError.value = err.message || 'Failed to load departments and shifts'
  } finally {
    optionsLoading.value = false
  }
}

function resetAttendancePage() {
  filters.value = emptyFilters()
  rows.value = []
  hasSearched.value = false
  searchedWithMonth.value = false
  activeReportType.value = 'Summary'
  sortKey.value = 'fullName'
  sortOrder.value = 'asc'
  errorMessage.value = ''
  isSaving.value = false
}

async function findAttendance() {
  if (!canFindAttendance.value) return
  if (!isAttendanceDeviceEnabled.value) return
  errorMessage.value = ''

  if (!filters.value.searchKey) {
    errorMessage.value = 'Select a Search Key.'
    return
  }
  if (!filters.value.reportType) {
    errorMessage.value = 'Select a Report Type.'
    return
  }
  if (isIdSearch.value && !String(filters.value.employeeId || '').trim()) {
    errorMessage.value = 'Enter an ID Number.'
    return
  }
  if (isDepartmentSearch.value && !filters.value.departmentId) {
    errorMessage.value = 'Select a Department.'
    return
  }

  const usingMonth = Boolean(filters.value.month)
  let dateFrom = filters.value.dateFrom
  let dateTo = filters.value.dateTo

  if (usingMonth) {
    const range = getMonthDateRange(filters.value.month)
    dateFrom = range.dateFrom
    dateTo = range.dateTo
    if (!dateFrom || !dateTo) {
      errorMessage.value = 'Unable to resolve the selected month date range.'
      return
    }
  } else {
    if (!dateFrom) {
      errorMessage.value = 'Date From is required.'
      return
    }
    if (!isMonthlyConfirm.value && !dateTo) {
      errorMessage.value = 'Date To is required.'
      return
    }
  }

  if (isShiftSchedule.value && !filters.value.shiftId) {
    errorMessage.value = 'Select a Shift Type.'
    return
  }
  if (
    !isMonthlyConfirm.value &&
    dateTo &&
    dateFrom > dateTo
  ) {
    errorMessage.value = 'Date From must be on or before Date To.'
    return
  }

  loading.value = true
  hasSearched.value = true
  searchedWithMonth.value = usingMonth
  activeReportType.value = filters.value.reportType || 'Summary'
  sortKey.value = 'fullName'
  sortOrder.value = 'asc'

  try {
    const params = new URLSearchParams()
    params.set('searchKey', filters.value.searchKey)
    params.set('reportType', filters.value.reportType)
    params.set('dateFrom', dateFrom)
    if (!isMonthlyConfirm.value && dateTo) {
      params.set('dateTo', dateTo)
    }
    if (isIdSearch.value) params.set('employeeId', String(filters.value.employeeId).trim())
    if (isDepartmentSearch.value) params.set('departmentId', filters.value.departmentId)
    if (isShiftSchedule.value) params.set('shiftId', filters.value.shiftId)

    const response = await apiFetch(`${API_BASE}/find?${params.toString()}`)
    if (!response.ok) {
      const err = await response.json().catch(() => ({}))
      throw new Error(err.message || 'Failed to find attendance')
    }

    const data = await response.json().catch(() => [])
    rows.value = Array.isArray(data) ? data : []
  } catch (err) {
    console.error('Error finding attendance:', err)
    rows.value = []
    errorMessage.value = err.message || 'Failed to find attendance'
  } finally {
    loading.value = false
  }
}

function buildSummarySaveEmployeesPayload() {
  return rows.value.map((row) => {
    const absent = row.absentDays != null && row.absentDays !== '' ? Number(row.absentDays) : 0
    const leaveDays = row.leaveDays != null && row.leaveDays !== '' ? Number(row.leaveDays) : 0
    const dueDate = row.totalDays != null && row.totalDays !== '' ? Number(row.totalDays) : 0
    return {
      userId: Number(row.userId ?? row.id ?? row.empId),
      companyId: row.companyId != null ? Number(row.companyId) : null,
      branchId: row.branchId != null ? Number(row.branchId) : null,
      dueDate: Number.isFinite(dueDate) ? dueDate : 0,
      overtime: [],
      totalHrs: 0,
      absent: Number.isFinite(absent) ? absent : 0,
      leaveDays: Number.isFinite(leaveDays) ? leaveDays : 0,
    }
  }).filter((emp) => Number.isFinite(emp.userId) && emp.userId > 0)
}

async function onSaveSummary() {
  if (isSaving.value) return
  if (!canSaveAttendance.value) return
  if (!showSaveButton.value) return

  errorMessage.value = ''

  const month = Number(filters.value.month)
  if (!month || month < 1 || month > 12) {
    showToast('Select a month before saving.', 'error')
    return
  }

  const employees = buildSummarySaveEmployeesPayload()
  if (!employees.length) {
    showToast('No employees to save.', 'error')
    return
  }

  const dueDateDefault = employees.reduce((max, emp) => {
    const n = Number(emp.dueDate)
    return Number.isFinite(n) && n > max ? n : max
  }, 0)

  isSaving.value = true
  try {
    const response = await apiFetch(`${API_BASE}/save-summary`, {
      method: 'POST',
      body: JSON.stringify({
        departmentId: isDepartmentSearch.value ? (filters.value.departmentId || null) : null,
        month,
        fromDate: null,
        toDate: null,
        dueDate: dueDateDefault,
        employees,
      }),
    })
    const data = await response.json().catch(() => ({}))
    if (!response.ok) {
      showToast(data.message || 'Failed to save attendance.', 'error')
      return
    }
    showToast(data.message || 'Attendance saved successfully.', 'success')
    resetAttendancePage()
  } catch (err) {
    console.error('Error saving summary attendance:', err)
    showToast(err.message || 'Failed to save attendance.', 'error')
  } finally {
    isSaving.value = false
  }
}

onMounted(() => {
  loadFilterOptions()
})
</script>

<style scoped>
table {
  font-family: 'Segoe UI', sans-serif;
  font-size: 11px;
  line-height: 1.15;
  color: #1e293b;
}

th, td {
  padding: 3px 15px;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
}

th {
  background: #f1f5f9;
  cursor: default;
  font-weight: 600;
}

th.sort-col {
  cursor: pointer;
}

th.sort-col:hover {
  background: #e2e8f0;
}

tbody tr:hover {
  background: #f8fafc;
}

tfoot th {
  background: #f1f5f9;
  font-weight: 600;
}

tfoot .footer-label {
  text-align: right;
}

.status-pill {
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: bold;
}

.active { background: #dcfce7; color: #166534; }
.inactive { background: #fee2e2; color: #991b1b; }

.punch-success {
  color: #15803d;
  font-weight: 700;
}

.punch-danger {
  color: #dc2626;
  font-weight: 600;
}
</style>
